<template>
    <b-modal
        v-model="hashChanged"
        hideFooter
        :title="$t('main.checkVersion.title')"
        footerClass="justify-content-around btn-modal"
        centered
        headerCloseContent=""
    >
        <p>{{ $t('main.checkVersion.text') }}</p>
        <b-button
            variant="success"
            class="mt-3"
            block
            @click="reloadApp"
        >
            {{ $t('main.checkVersion.button') }}
        </b-button>
    </b-modal>
</template>

<script>
import params from '@/config/params';
const TWO_MINUTES = 120000;

export default {
    name: 'CheckVersion',
    data() {
        return {
            currentHash: null,
            hashChanged: false,
            newHash: '',
        };
    },

    methods: {
        initVersionCheck(url, frequency = TWO_MINUTES) {
            setInterval(() => {
                this.checkVersion(url);
            }, frequency);
        },

        async checkVersion(url) {
            const fileResponse = await this.axios.get(url + '?t=' + new Date().getTime(), { baseURL: null });

            this.newHash = fileResponse.data.hash;

            if (!this.currentHash) {
                this.currentHash = this.newHash;
            }

            this.hashChanged = this.hasHashChanged(this.currentHash, this.newHash);
        },

        hasHashChanged(currentHash, newHash) {
            return currentHash !== newHash;
        },

        reloadApp() {
            this.currentHash = this.newHash;
            this.reloadWithTimestamp();
        },

        reloadWithTimestamp() {
            const url = new URL(window.location.href);
            url.searchParams.set('_', Date.now());
            window.location.replace(url.toString());
        },
    },

    mounted() {
        if (params.env === 'prod') {
            this.initVersionCheck('/version.json');
        }
    },
};
</script>